module.exports = __webpack_public_path__ + "static/media/edit.dd1410d7.svg";